import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import {
  selectClientConfig,
  selectCurrentAddressData,
  selectPersonalClientSubscriptionData,
} from '../../../../SubscriptionForm/SubscriptionFormSelectors'
import { updateClientData } from '../../../../SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'

const useNewsletterField = isNewsletterRegistered => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { lang } = useSelector(selectAuthData)
  const { firstName, lastName, phone1, email, zohoId } = useSelector(selectPersonalClientSubscriptionData)
  const { newsletterData, newsletterLoading, newsletterError, newsletterCanBeSent } = useSelector(selectClientConfig)
  const { electricityMeter } = useSelector(selectCurrentAddressData)

  const emailRef = useRef(email)
  const pdlNo = electricityMeter?.pdlNo ?? ''
  const isFrench = lang === 'fr'

  const sendNewsletter = () => {
    dispatch({
      type: subscriptionFormActionsV2.CUSTOMER_MODULE_REGISTER_TO_NEWSLETTER_V2,
      requestErrorMsg: t('subscriptionForm:customer_module.newsletter.request_error'),
    })
  }

  useEffect(() => {
    const isMissingDataToSendNewsletter = !zohoId || !lastName || !firstName || !phone1 || !email
    dispatch(
      updateClientData({
        data: {
          newsletterCanBeSent: !isMissingDataToSendNewsletter,
        },
        name: 'config',
      }),
    )
  }, [zohoId, lastName, firstName, phone1, email])

  useEffect(() => {
    emailRef.current = email
  }, [email])

  useEffect(() => {
    if (!zohoId) {
      return
    }

    window.Echo.channel(`register.newsletter.${zohoId}`)
      .listen('.operation.success', e => {
        console.log('Newsletter Success:', e)
        if (e.data.email !== emailRef.current) {
          return
        }
        dispatch(
          updateClientData({
            data: {
              newsletterLoading: false,
              newsletterData: { ...e.data.response, status: e.data.status },
              newsletterCanBeSent: false,
            },
            name: 'config',
          }),
        )
      })
      .listen('.operation.failed', e => {
        console.error('Newsletter Error:', e)
        if (e.control_value !== emailRef.current) {
          return
        }
        dispatch(
          updateClientData({
            data: {
              newsletterError: t('subscriptionForm:customer_module.newsletter.request_error') + ' : ' + e.error,
              newsletterLoading: false,
            },
            name: 'config',
          }),
        )
      })
    return () => {
      window.Echo.leaveChannel(`register.newsletter.${zohoId}`)
    }
  }, [zohoId])

  return {
    sendNewsletter,
    email,
    newsletterCanBeSent,
    newsletterError,
    t,
    newsletterLoading,
    newsletterData,
    status: newsletterData?.status || '',
    franceNoPdlNotRegistered: isFrench && !pdlNo && !isNewsletterRegistered,
    franceWithPdl: isFrench && pdlNo,
  }
}

export default useNewsletterField
